import type { MediaItem } from "@/lib/media";
import MediaCard from "@/components/feature/MediaCard";

interface MediaGridProps {
  items: MediaItem[];
  showSynopsis?: boolean;
}

export default function MediaGrid({ items, showSynopsis = false }: MediaGridProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
      {items.map((item) => (
        <MediaCard key={item.id} item={item} showSynopsis={showSynopsis} />
      ))}
    </div>
  );
}